<template>
  <div class="AiSpaActivityCard">
    <div
      class="AiSpaActivityCard-body"
      :aria-label="$t('accessibility.description.spaActivityCard')">
      <div v-if="picture" class="AiSpaActivityCard-image">
        <ai-image
          :src="picture.src"
          :alt="picture.alt ?? ''"
          :src-set="picture?.srcSet as string"
          provider="raw"
          loading="lazy" />
      </div>

      <div
        class="AiSpaActivityCard-informations"
        :aria-label="$t('accessibility.description.spaActivityCardTitle')">
        <ai-typo
          class="AiSpaActivityCard-informations-title"
          as="h3"
          variant="heading-04">
          {{ title }}
        </ai-typo>

        <ai-typo
          as="p"
          variant="paragraph-04-regular"
          :aria-label="
            $t('accessibility.description.spaActivityCardDescription')
          ">
          {{ description }}
        </ai-typo>

        <ai-button
          class="AiSpaActivityCard-menuCta"
          v-if="menuUrl"
          as-link
          variant="tertiary"
          :icon-right="'button-arrow-right' as IconName"
          :aria-pressed="ariapressed"
          :label="$t('hotel.spaActivities.cta')"
          :aria-label="$t('accessibility.description.spaActivityMenuButton')"
          :url="menuUrl"
          target="_blank"
          slim
          small />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { AiPicture, Maybe } from '~/domains/graphql';
import type { IconName } from '~/domains/ux/atoms/AiIcon/types';

export interface AiSpaActivityCard {
  title: Maybe<string>;
  description: Maybe<string>;
  picture: Maybe<AiPicture>;
  menuUrl: Maybe<string>;
}
defineProps<AiSpaActivityCard>();

const ariapressed = ref<boolean>(false);
</script>

<style scoped lang="scss">
@use '@/assets/styles/utilities/constants';
@use '@/assets/styles/utilities/mq';

.AiSpaActivityCard-image {
  width: 100%;
  height: 200px;

  object-fit: cover;
  object-position: center;

  @media (mq.$from-medium) {
    width: 70%;
    height: 428px;
  }
}

.AiSpaActivityCard-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: constants.$margin-02;
  text-align: center;

  @media (mq.$from-medium) {
    height: 428px;
    flex-direction: row;
    text-align: left;
  }
}

.AiSpaActivityCard-informations {
  display: block;
  padding-left: constants.$padding-01;
  padding-right: constants.$padding-01;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (mq.$from-medium) {
    height: 428px;
    width: 30%;
    overflow-y: auto;
  }
}

.AiSpaActivityCard-informations-title {
  margin-bottom: constants.$margin-00;
}

.AiSpaActivityCard-menuCta {
  margin-top: constants.$margin-02;
}
</style>
